import { render, staticRenderFns } from "./BoCard.vue?vue&type=template&id=9eb80764&scoped=true"
import script from "./BoCard.vue?vue&type=script&lang=js"
export * from "./BoCard.vue?vue&type=script&lang=js"
import style0 from "./BoCard.vue?vue&type=style&index=0&id=9eb80764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb80764",
  null
  
)

export default component.exports